import type { UpdateMeasurementRequest } from '@vy/api-definition';
import { MeasurementSchema, type Measurement } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateMetersQueries } from '../../utils/query-invalidation';

export function useUpdateMeasurement(
  options?: UseMutationOptions<Measurement, unknown, UpdateMeasurementRequest & { id: string }>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...newMeasurement }) => {
      const api = getPrivateApi();

      const updateMeasurementResponse = await api.updateMeasurement({
        measurementId: id,
        updateMeasurementRequest: {
          units: newMeasurement.units,
        },
      });

      return MeasurementSchema.parse(updateMeasurementResponse);
    },
    onSuccess: async () => {
      await invalidateMetersQueries(queryClient);
    },
    ...options,
  });
}
